export { default } from './ContingentBadge'
